import * as types from "../types/CleaningTypes";

export const updateBathrooms = bathroomNum => {
  return {
    type: types.UPDATE_BATHROOMS,
    payload: bathroomNum
  };
};
export const updateBedrooms = bedroomNum => {
  return {
    type: types.UPDATE_BEDROOMS,
    payload: bedroomNum
  };
};
export const toggleAddon = addon => {
  return {
    type: types.TOGGLE_ADDON,
    payload: addon
  };
};
export const updateFrequency = frequency => {
  return {
    type: types.UPDATE_FREQUENCY,
    payload: frequency
  };
};
export const updateDate = date => {
  return {
    type: types.UPDATE_DATE,
    payload: date
  };
};
export const updateTime = time => {
  return {
    type: types.UPDATE_TIME,
    payload: time > 12 ? `${time - 12} PM` : `${time} AM`
  };
};
export const cleaningScheduled = cleaning => {
  return {
    type: types.CLEANING_SUCCESS,
    payload: cleaning
  };
};



// WEBPACK FOOTER //
// ./src/actions/CleaningActions.js